import { useEffect } from "react";
import { useTranslation } from "@shared/utils/internationalization";
import Text from "@shared/components/ui-kit/typography/Text/Text.web";
import Box from "@shared/components/ui-kit/layout/Box/Box.web";

export function PaymentSectionFreeBaskets({
  onValid,
}: {
  onValid: () => void;
}) {
  const { t } = useTranslation("checkout");

  useEffect(() => {
    // No payment required, no billing address required. Instantly valid
    onValid();
  }, []);

  return (
    <Box marginTop="md" marginBottom="md">
      <Text fontSize="md" color="font.dark">
        {t("Your cart is 100% free. Enjoy!")}
      </Text>
    </Box>
  );
}
